// src/app-version/types/AppVersionHeaders.ts
var APP_BUILD_HEADER = "x-app-build";
var RELOAD_REQUIRED_HEADER = "x-reload-required";
var MIN_APP_BUILD_HEADER = "x-min-app-build";

export {
  APP_BUILD_HEADER,
  RELOAD_REQUIRED_HEADER,
  MIN_APP_BUILD_HEADER
};
